import { axiosInstance } from "../axiosInstance";

export const getDestinations = async (searchTerm, difficulty, type, isChildFriendly, isTraverse, pageNumber = 1) => {
    const params = new URLSearchParams();

    if (searchTerm) params.append("q", searchTerm);
    if (difficulty) params.append("difficulty", difficulty);
    if (type) params.append("type", type);
    if (pageNumber) params.append("pageNumber", 2);
    if (typeof isChildFriendly === "boolean") params.append("isChildFriendly", isChildFriendly);
    if (typeof isTraverse === "boolean") params.append("isTraverse", isTraverse);
    
    const { data } = await axiosInstance.get(`api/destinations?${params.toString()}`)
    return data;
}

export const AddImage = async ( destinationId, image, caption, isDisplayImage ) => {
    try 
    {
        const formData = new FormData();
        formData.append("image", image); 
        formData.append("caption", caption);
        formData.append("isDisplayImage", isDisplayImage);

        const { data } = await axiosInstance.post(`api/destinations/${destinationId}/images`, formData)
        return data;
    }
    catch(error)
    {
        throw error;
    }
}

export const getDestinationOptions = async () => {
    try 
    {
        const { data } = await axiosInstance.get(`api/destinations/options`)
        return data;
    }
    catch(error)
    {
        throw error;
    }
}

export const AddDestination = async ( destination ) => {
    try 
    {
        const { data } = await axiosInstance.post(`api/destinations`, destination)
        return data;
    }
    catch(error)
    {
        throw error;
    }
}

export const UpdateDestination = async (destination) => {
  try {
    const {destinationId, ...newDestination} = destination;
    console.log(newDestination)
    const { data } = await axiosInstance.put(
      `api/destinations/${destination.destinationId}`,
      newDestination
    );
    return data;
  } catch (error) {
    throw error;
  }
};


export const DeleteDestination = async (destination) => {
  try {
    const { data } = await axiosInstance.delete(`api/destinations/${destination.destinationId}`);
    console.log(data)
    return data;
  } catch (error) {
    throw error;
  }
};
export const getDestinationImage = async (isDisplayImage, destinationId) => {
    const params = new URLSearchParams();
    if (typeof isDisplayImage === "boolean") params.append("isDisplayImage", isDisplayImage);
    
    const { data } = await axiosInstance.get(`api/destinations/${destinationId}/images?${params.toString()}`)
    return data;
}